export const EVENT_TICKET_CHECKOUT_FLOW = 'event_ticket';

export function validateEventTicketCheckoutAcceptance(input: {
  refundPolicyText?: string | null;
  acceptRefundPolicy: boolean;
}): { ok: boolean; message?: string } {
  if (!input.refundPolicyText?.trim()) {
    return { ok: false, message: 'Refund policy is required before checkout' };
  }
  if (!input.acceptRefundPolicy) {
    return { ok: false, message: 'Accept the refund policy to continue' };
  }
  return { ok: true };
}

export function computeEventTicketPlatformFeeCents(amountCents: number, feePercent: number): number {
  if (amountCents <= 0 || feePercent <= 0) return 0;
  return Math.round((amountCents * feePercent) / 100);
}
